// extracted by mini-css-extract-plugin
module.exports = {"wrapper-inline":"_forms_wrapper-inline__1x6e6","inline-fields":"_forms_inline-fields__3CXi6"};